/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Component } from 'react';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { MLModalService } from 'ml-portals-services-react';
import {MLFormUtil, MLLocalDateUtil} from 'ml-portals-util-js';
import { MLGatewayAccountBillingDetailsService } from 'gw-capability-gateway-billing';
import { platformMessages } from 'ml-components-platform-react';
import { MLTagManagerService } from 'ml-portals-services-react'
import PropTypes from 'prop-types';

import _ from 'lodash';
import metadata from './MLAccountBillingAvailableDocument.metadata.json5';

import messages from './MLAccountBillingAvailableDocument.messages';
import styles from './MLAccountBillingAvailableDocument.module.scss';
import { Button } from '@jutro/legacy/components';

import { Link } from '@jutro/router';

import { TranslatorContext, withIntl } from '@jutro/legacy/locale';

const {
    showProgressDialog,
    showErrorModal,
    hideProgressDialog
} = MLModalService();

// account/MLAvailableDocumentsCtrl.js, ml-available-documents-billing
class MLAccountBillingAvailableDocument extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        location: PropTypes.shape({
            state: PropTypes.string,
            pathname: PropTypes.string
        }).isRequired,

        authenticated: PropTypes.bool.isRequired,
        authHeader: PropTypes.shape({}).isRequired,
    };

    constructor(props) {
        super(props);

        const { viewModelService } = props;

        const isUserRetentionAgent = () => {
            const producerCodes = this.props.authUserData.producerCodes_ML;
            return producerCodes && !!producerCodes.find((c) => c.IsDocRetention_ML === true);
        };

        const {
            bundledPaymentRequest,
            usePaymentusAch,
            paymentInstrument,
            onetimePaymentForm
        } = this.props.history.location.state;

        this.state = {
            bundledPaymentRequest: bundledPaymentRequest,
            paymentInstrument: paymentInstrument,
            onetimePaymentForm: onetimePaymentForm,
            signatureTypeList: viewModelService.productMetadata.get('pc').types.getTypelist('SignatureType_ML').codes,
            isUserRetentionAgent: isUserRetentionAgent(),
            usePaymentusAch: usePaymentusAch
        };
    }

    viewDocument = () => {
        const form = this.state.onetimePaymentForm;
        const policyNumbers = [];
        for (let i = 0; i < this.state.bundledPaymentRequest.paymentRequests.length; ++i) {
            policyNumbers[i] = this.state.paymentRequests[i].policyNumber;
        }

        const errorCallback = () => {
            hideProgressDialog();
            showErrorModal(
                platformMessages.error,
                platformMessages.unableToDownloadDocument
            );
        };
        const viewFormPromise = MLFormUtil.viewForm(errorCallback, form, form.sessionID, form.primaryPolicyNumber, form.policyPeriodPublicID, this.state.paymentInstrument.token, policyNumbers, this.props.authHeader);
        showProgressDialog(platformMessages.downloadingDocument, viewFormPromise);
    };

    showConfirmationInfo = (res) => {
        const confirmation = {};
        confirmation.confirmations = res;
        confirmation.effectiveDate = res[0].effectiveDate;
        if (typeof (confirmation.effectiveDate) === 'object') {
            confirmation.effectiveDate = MLLocalDateUtil.localDate2Date(confirmation.effectiveDate);
        }
        confirmation.last4Digits = this.state.paymentInstrument.last4Digits;
        confirmation.nickname = this.state.paymentInstrument?.nickname ? this.state.paymentInstrument?.nickname : this.state.paymentInstrument?.accountType_ML;

        this.props.history.push({
            pathname: 'billingConfirmation',
            state: {
                confirmation: confirmation
            }
        });
    };

    makeOneTimePayment = () => {
        let paymentPromise = null;
        if (this.state.usePaymentusAch) {
            paymentPromise = MLGatewayAccountBillingDetailsService.makePayment(
                this.state.bundledPaymentRequest,
                this.props.authHeader
            );
        } else {
            paymentPromise = MLGatewayAccountBillingDetailsService.makeBankAccountPayment(
                this.state.bundledPaymentRequest.paymentRequests,
                this.props.authHeader
            );
        }

        const translator = this.context;
        showProgressDialog(translator(messages.processingPayment), paymentPromise);

        // TODO: handle payment errors appropriately
        paymentPromise.then((res) => {
            if (res.length === 1 && res[0].reversed) {
                this.refreshData();
            } else {
                MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_Continue`);
                this.showConfirmationInfo(res);
            }
        }).catch((error) => {
            console.error(error);
        });
    };

    render() {
        const translator = this.context;

        const formatDate = (date) => {
            const { intl } = this.props;
            return intl.formatDate(new Date(date), { year: 'numeric', month: 'short', day: 'numeric' });
        };

        const generateDocumentColumn = () => {
            return (
                <div className="font-weight-bold">{this.state.onetimePaymentForm.formDescription}</div>
            );
        };

        const generateSignatureTypeColumn = () => {
            const getSignatureTypeName = (code) => {
                const type = this.state.signatureTypeList.find((v) => v.code === code);
                return translator({ id: type.name, defaultMessage: type.code });
            };

            return (
                <>
                    {this.state.onetimePaymentForm.isSigned === true &&
                        <div className="icon-ml-status-check-complete icon-green" />
                    }
                    <span className={this.state.onetimePaymentForm.isSigned === true ? 'ml-bold' : ''}>
                        {getSignatureTypeName(this.state.onetimePaymentForm.signatureType)}
                    </span>
                </>
            );
        };

        const generateDateSignedColumn = () => {
            return (
                <>
                    {this.state.isUserRetentionAgent && (
                        <>
                            {this.state.onetimePaymentForm.signatureType === 'esignature' && (
                                <>
                                    {this.state.onetimePaymentForm.isSigned === true &&
                                        <span>{formatDate(this.state.onetimePaymentForm.signedDateTime)}</span>
                                    }
                                    {this.state.onetimePaymentForm.isSigned !== true &&
                                        <span>-</span>
                                    }
                                </>
                            )}
                            {this.state.onetimePaymentForm.signatureType === 'esignature' &&
                                <span><strong>{translator(messages.documentRetention)}</strong></span>
                            }
                        </>
                    )}
                    {!this.state.isUserRetentionAgent && (
                        <>
                            {this.state.onetimePaymentForm.isSigned === true &&
                                <span>{formatDate(this.state.onetimePaymentForm.signedDateTime)}</span>
                            }
                            {this.state.onetimePaymentForm.isSigned !== true &&
                                <span>-</span>
                            }
                        </>
                    )}
                </>
            );
        };

        const generateActionColumn = () => {
            return (
                <>
                    {this.state.onetimePaymentForm.formLanguage && (
                        <>
                            <Link className='mlLink' onClick={() => this.viewDocument()}>{translator(messages.viewEnglish)}</Link>
                            <Link className='mlLink' onClick={() => this.viewDocument()}>{translator(messages.viewSpanish)}</Link>
                        </>
                    )}
                    {!this.state.onetimePaymentForm.formLanguage && (
                        <Link className='mlLink' onClick={() => this.viewDocument()}>{translator(messages.view)}</Link>
                    )}
                </>
            );
        };

        const overrides = {
            formTable: {
                data: [this.state.onetimePaymentForm]
            },
            documentColumn: {
                cell: generateDocumentColumn
            },
            signatureTypeColumn: {
                cell: generateSignatureTypeColumn
            },
            dateSignedColumn: {
                cell: generateDateSignedColumn
            },
            actionColumn: {
                cell: generateActionColumn
            }
        };
        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                makeOneTimePayment: this.makeOneTimePayment
            }
        };

        const avaiableDocumentPage = <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
        return (
            <div>
                {avaiableDocumentPage}
            </div>
        );
    }
}

export const AccountBillingAvailableDocument = MLAccountBillingAvailableDocument;
export default withIntl(withViewModelService(withAuthenticationContext(MLAccountBillingAvailableDocument)));